import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"file",
    list_id:"wfile_frame_list",
    x_column_list_arr:[
      {"key":"row_view_thum","name":"썸네일","width":"70"},
      {"key":"a_oriname","name":"파일명","width":"100"},
      {"key":"row_view_down","name":"다운","width":"50"},
      {"key":"a_size","name":"크기","width":"50"},
      {"key":"a_sort3","name":"구분","width":"50"},
      {"key":"a_writer","name":"작성자","width":"60"},
      {"key":"a_create_date","name":"작성일","width":"130"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_title',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_category_seq":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;